import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Input } from 'components/molecules/v2/input';
import InputWithLabel from 'components/molecules/input-with-label';
import { useAuthState } from 'src/components/auth/hook';
import { validationSchema } from 'src/components/partners/signup/validations';
import { PARTNER_SIGNUP } from 'src/formMapper';

const SignupVerifyForm = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const { client } = useAuthState();

  const {
    handleSubmit,
    register,
    watch,
    getValues,
    formState: { isSubmitting, errors }
  } = useForm({
    shouldFocusError: false,
    resolver: yupResolver(validationSchema),
    mode: 'onChange'
  });

  const onFormSubmit = async (values) => {
    const utmParams = localStorage.getItem('utmParams') ? JSON.parse(localStorage.getItem('utmParams')) : {};

    await client.post('/partner/signup/', {
      full_name: values.full_name, // Not Mandatory
      email: values.email,
      is_superuser: true,
      utm_source: utmParams?.utm_source,
      utm_medium: utmParams?.utm_medium,
      utm_campaign: utmParams?.utm_campaign
    });

    setFormSubmitted(true);
  };

  return (
    <>
      {!formSubmitted && (
        <form onSubmit={handleSubmit(onFormSubmit)}>
          <div className='grid grid-cols-1 gap-4 lg:max-w-md'>
            <InputWithLabel
              label={PARTNER_SIGNUP.full_name.label}
              name='full_name'
              error={!!errors.full_name}
              errorMessage={errors?.full_name?.message}
              labelSize='large'
            >
              <Input
                name='full_name'
                type='text'
                placeholder={PARTNER_SIGNUP.full_name.placeholder}
                error={!!errors.full_name}
                errorMessage={errors?.full_name?.message}
                register={register}
                value={watch('full_name')}
              />
            </InputWithLabel>
            <InputWithLabel
              label={PARTNER_SIGNUP.email.label}
              name='email'
              error={!!errors.email}
              errorMessage={errors?.email?.message}
              labelSize='large'
            >
              <Input
                name='email'
                type='email'
                placeholder={PARTNER_SIGNUP.email.placeholder}
                error={!!errors.email}
                errorMessage={errors?.email?.message}
                register={register}
                value={watch('email')}
              />
            </InputWithLabel>
          </div>
          <div className='mt-8'>
            <button
              type='submit'
              text='Login'
              disabled={isSubmitting}
              aria-disabled={isSubmitting}
              className='app-btn app-btn-primary group'
              data-testid='submit'
            >
              <img src='/icons/email-white.svg' className='w-4' />
              <span>{PARTNER_SIGNUP.button.submit}</span>
            </button>
          </div>
        </form>
      )}
      {formSubmitted && (
        <div className='pt-2 pb-8'>
          <div className='px-[10px] py-2 border border-green-400 rounded-full bg-green-50 inline-block'>
            <div className='flex items-center'>
              <div className='flex-shrink-0'>
                <img src='/icons/success-icon.svg' className='w-[18px] h-[18px]' />
              </div>
              <div className='ml-2'>
                <p className='app-text-dm-small text-gray text-opacity-80'>
                  Email sent successfully on {getValues('email')}
                </p>
              </div>
            </div>
          </div>
          <div className='mt-4'>
            <p className='space-x-1 leading-snug app-text-dm-small text-gray opacity-90'>
              Email ID incorrect?
              <a href='#' onClick={() => setFormSubmitted(false)} data-testid='change-email-id'>
                <span className='uppercase app-text-link text-secondary'> change id here</span>
              </a>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

SignupVerifyForm.propTypes = {};

export default SignupVerifyForm;
